// Copyright (C) 2021 Bystronic Laser AG

import { metricsService } from '@/services/metrics.service';
import { LaserTubeDeviceStateData } from '../deviceStateData';
import { FilterTimeAxisSpanEnum } from '../enums/FilterTimeAxisSpanEnum';
import { FilterTimeSpanEnum } from '../enums/FilterTimeSpanEnum';
import { DataRetriever, ProcedureName } from './abstract/chartGenerator';

export class WorkCenterConsoleOverviewStateDataRetriever extends DataRetriever<
  LaserTubeDeviceStateData[]
> {
  constructor(procedure: ProcedureName, private customerIdDh: number) {
    super(procedure);
  }

  override async getData(
    selectedDevices: string[],
    selectedShifts: number[],
    timeSpan: FilterTimeSpanEnum | [string, string],
    timeAxisSpan?: FilterTimeAxisSpanEnum,
    params?: { [key: string]: any },
  ): Promise<LaserTubeDeviceStateData[]> {
    return await metricsService.getDevicesMetrics(
      this.procedure,
      {
        tenantIdDh: this.customerIdDh,
        deviceIds: selectedDevices,
        shifts: selectedShifts,
        timeSpan: timeSpan as FilterTimeSpanEnum,
        statesOnly: params?.statesOnly,
      },
      this.controller,
    );
  }
}
